import React from 'react'

import useTranslation from '../../../context/hooks/useTranslation'
import WarnIcon from '../../../vectors/WarnIcon'

export const ScanResultInDayNetwork: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="shadow-elevation-2 flex h-[537px] w-[840px] flex-row overflow-hidden rounded-lg bg-white">
      <div className="bg-yellow-50 flex w-1/2 flex-col items-center justify-center gap-4">
        <WarnIcon color="#000000" large />
        <span className="font-heading text-center text-[40px] text-yellow-dark-fade">
          {t('IN_DAY_NETWORK')}
        </span>
      </div>

      <div className="flex w-1/2 flex-col items-start px-6 pt-32 text-indigo-50">
        <div className="flex flex-col">
          <span className="font-heading text-h3 text-center">
            {t('IN_DAY_NETWORK_TITLE')}
          </span>
          <span className="font-body text-md text-center">
            {t('IN_DAY_NETWORK_DESCRIPTION')}
          </span>
        </div>
      </div>
    </div>
  )
}

export default ScanResultInDayNetwork
